import { Component, Input, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-input-field',
  templateUrl: './input-field.component.html',
  styleUrls: ['./input-field.component.css']
})
export class InputFieldComponent {
  @Input() type: string;
  @Input() id: string;
  @Input() controlName: string;
  @Input() key: string;
  @Input() form: FormGroup;
  @Input() class = 'field';
  @Input() min = 0;
  @Input() max: number;
  @Input() minlength: number;
  @Input() maxlength: number;
  @Input() isInteger = false;
  @Input() hideLabel = false;
  @Input() hideErrors = false;
  @Input() autofocus = false;
  @Input() step = null;
  @ViewChild('error') error;
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/forms/input-field/input-field.component.ts